module.controller('brandCtrl', [
  '$scope',
  '$rootScope',
  '$stateParams',
  'brandService',
  'DEFAULT_BRAND',
  'Session',
  function (
    $scope,
    $rootScope,
    $stateParams,
    brandService,
    DEFAULT_BRAND,
    Session
  ) {

    $scope.default_brand = DEFAULT_BRAND;

    $scope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState, fromParams) {
      var currentBrand;
      var sessionBrand = Session.getBrand();

      if (sessionBrand === undefined) {
        currentBrand = DEFAULT_BRAND;
        Session.setBrand(currentBrand);
      } else {
        currentBrand = sessionBrand;
      }

      if ($stateParams.brand !== undefined && $stateParams.brand !== sessionBrand) {
        currentBrand = $stateParams.brand;
        Session.setBrand(currentBrand);
      }

      $scope.brand = brandService.getBrand(currentBrand);
      // $rootScope used just to inject the brand on the <title> tag
      $rootScope.brand = brandService.getBrand(currentBrand);

      var helpChatOnBrands = [
        'akimbo',
        'akimboco',
        'nowincentive',
        'nowcard',
        'nowpromo',
      ];

      var displayChat = false;
      for (var i=0; i<helpChatOnBrands.length; i++) {
        if ($scope.brand.name === helpChatOnBrands[i]) {
          displayChat = true;
        }
      }
      if (displayChat && !window.adaSettings) {
        var chatScript = document.createElement('script');
        chatScript.type = 'text/javascript';

        chatScript.id = '__ada';
        chatScript.async = false;
        chatScript.src = 'https://static.ada.support/embed2.js';

        window.adaSettings = {
          handle: 'usio-gr',
          crossWindowPersistence: true,
          align: 'left',
        };

        document.body.appendChild(chatScript);
      }

    });
}]);
